import {
  QualificationVisibilityScope,
  UserAssignedQualificationStatusType,
  RequestScope,
} from '@tabeeb/contracts/microservices/swagger-certificate-service'

export const UserAssignedQualificationStatusTypeDisplayName: Record<UserAssignedQualificationStatusType, string> = {
  [UserAssignedQualificationStatusType.Pending]: 'Waiting for certificates',
  [UserAssignedQualificationStatusType.Active]: 'Active',
  [UserAssignedQualificationStatusType.Revoked]: 'Revoked',
  [UserAssignedQualificationStatusType.CertificateExpired]: 'Certificate expired',
  [UserAssignedQualificationStatusType.VersionExpired]: 'Version expired',
  [UserAssignedQualificationStatusType.CertificateTypeDeleted]: 'Type deleted',
  [UserAssignedQualificationStatusType.QualificationDeleted]: 'Qualification deleted',
}

export const QualificationVisibilityScopeDisplayName: Record<QualificationVisibilityScope, string> = {
  [QualificationVisibilityScope.Corporation]: 'Corporation',
  [QualificationVisibilityScope.Tenant]: 'Tenant',
}

export { UserAssignedQualificationStatusType, QualificationVisibilityScope, RequestScope as Scope }
